import { OAuthLogger } from 'angular-oauth2-oidc';

export class OAuthLoggerImplement extends OAuthLogger {
  debug(message: any, ...args: any[]): void {
    console.debug(message, ...args);
  }
  info(message: any, ...args: any[]): void {
    console.info(message, ...args);
  }
  warn(message: any, ...args: any[]): void {
    console.warn(message, ...args);
  }
  error(message: any, ...args: any[]): void {
    console.error(message, ...args);
  }
  log(message: any, ...args: any[]): void {
    console.log(message, ...args);
  }
}
